/* eslint-disable array-callback-return */
import { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { Button, Container, Dimmer, Divider, Form, Grid, Header, Icon, Input, Loader, Message, Modal, Popup, Segment, Table, TextArea } from "semantic-ui-react";
import { useNavigate, useParams } from "react-router-dom";
import moment from "moment";
import Swal from "sweetalert2";
import ReactDOMServer from "react-dom/server";
import { auth, db } from "../firebase/firebaseConfig";
import { UserContext } from "../context/UserContext";
import useObtenerIngreso from "../hooks/useObtenerIngreso";
import PresupuestoCabDB from "../firebase/PresupuestoCabDB";
import PresupuestoDB from "../firebase/PresupuestoDB";
import EnviarCorreo from "../funciones/EnviarCorreo";
import TablaInfo from "./TablaInfo";
import { Timestamp, collection, deleteDoc, doc, getDocs, query, updateDoc, where, writeBatch } from "firebase/firestore";
import { useContext } from "react";
// import BitacoraBajaDB from "../firebase/BitacoraBajaDB"


const toMillisSafe = (x) => x?.toMillis ? x.toMillis() : x?.toDate ? x.toDate().getTime() : +new Date(x ?? 0);

const isEmpty = (v) => String(v ?? "").trim() === "";

const GenerarPresupuesto = () => {
  const navigate = useNavigate();
  const { id, ruta } = useParams();
  const { users } = useContext(UserContext);
  const user = auth.currentUser;

  const [ingreso] = useObtenerIngreso(id);

  const volver = useCallback(() => {
    navigate("/serviciotecnico/asignadostecnicos");
  }, [navigate]);

  // ===== UI =====
  const [loading, setLoading] = useState(false); // carga inicial + refresh
  const [saving, setSaving] = useState(false); // acciones (delete/confirm/send/etc)

  const [showCliente, setShowCliente] = useState(true);

  // buscador flotante
  const [buscador, setBuscador] = useState("");
  const [showResultados, setShowResultados] = useState(false);
  const [verTodos, setVerTodos] = useState(false);
  const [hover, setHover] = useState(null);

  // modales
  const [openDelete, setOpenDelete] = useState(false);
  const [deleteId, setDeleteId] = useState("");
  const [deleteCol, setDeleteCol] = useState(null); // "diag" | "ejec"

  const [openConfirmGenerar, setOpenConfirmGenerar] = useState(false);

  const [openSend, setOpenSend] = useState(false);
  const [nombre_out, setNombre_out] = useState("");
  const [correo_out, setCorreo_out] = useState("");

  const [openAceptar, setOpenAceptar] = useState(false);
  const [openRechazar, setOpenRechazar] = useState(false);

  // Estados Modal Baja Equipos
  // const [openBajaModal, setOpenBajaModal] = useState(false);
  // const [obsBaja, setObsBaja] = useState("");
  // const [idBitacoraCabBaja, setIdBitacoraCabBaja] = useState(null);
  // const [openFinalizar, setOpenFinalizar] = useState(false);

  // ===== DATA =====
  const [presupuestoCab, setPresupuestoCab] = useState([]); // presupuestoscab
  const [idCabPre, setIdCabPre] = useState(""); // id cabecera
  const [presupuesto, setPresupuesto] = useState([]); // presupuestos (detalle)

  // const [bajaCab, setBajaCab] = useState([]); // bitacoracabbajaEq
  // const [bajaDet, setBajaDet] = useState([]); // bitacorabajaEq

  const [items, setItems] = useState([]); // itemsst (FALLA/REPUESTO/SERVICIO/IRREPARABLE)
  // const [itemsEjecMaster, setItemsEjecMaster] = useState([]); // items (CHECK/MEDICION/SEGURIDAD)
  const [obs, setObs] = useState("");

  // flags de avance de UI
  const [mostrarAdd, setMostrarAdd] = useState(false);
  const [btnCabDisabled, setBtnCabDisabled] = useState(false);
  const [botonDisabled, setBotonDisabled] = useState(false);

  const documentoId = useRef("");
  // refs para no depender de indices
  // const cabIdRef = useRef("");

  // buscadores (separados para que no choque D/E)  
  // const [qEjec, setQEjec] = useState("");
  // const [showEjecResultados, setShowEjecResultados] = useState(false);
  // const [ejecVerTodos, setEjecVerTodos] = useState(false);
  // const [hoverId, setHoverId] = useState(null);

  // ===== Datos ingreso derivados =====
  const datos = useMemo(() => {
    if (!ingreso) return null;
    return {
      folio: ingreso.folio ?? "",
      rut: ingreso.rut ?? "",
      entidad: ingreso.entidad ?? "",
      date: ingreso.date ?? null,
      telefono: ingreso.telefono ?? "",
      direccion: ingreso.direccion ?? "",
      correo: ingreso.correo ?? "",
      familia: ingreso.familia ?? "",
      tipo: ingreso.tipo ?? "",
      marca: ingreso.marca ?? "",
      modelo: ingreso.modelo ?? "",
      serie: ingreso.serie ?? "",
      servicio: ingreso.servicio ?? "",
    };
  }, [ingreso]);

  const formatearFecha = useCallback((fecha) => {
    if (!fecha?.toDate) return "";
    return moment(fecha.toDate()).format("DD/MM/YYYY HH:mm");
  }, []);

  // ===== Helpers =====
  const fetchDocs = useCallback(async (q) => {
    const snap = await getDocs(q);
    return snap.docs.map((d) => ({ ...d.data(), id: d.id }));
  }, []);

  // token
  const generarTokenHex = useCallback((bytes = 32) => {
    const arr = new Uint8Array(bytes);
    window.crypto.getRandomValues(arr);
    return Array.from(arr)
      .map((b) => b.toString(16).padStart(2, "0"))
      .join("");
  }, []);

  // ===== Loads =====
  const loadPresupuestoCab = useCallback(async () => {
    if (!users?.emp_id || !id) return;

    const qCab = query(
      collection(db, "presupuestoscab"),
      where("emp_id", "==", users.emp_id),
      where("id_cab_inst", "==", id)
    );
    const rows = await fetchDocs(qCab);
    setPresupuestoCab(rows);

    if (rows.length) {
      const cab = rows[0];
      setIdCabPre(cab.id);
      documentoId.current = cab.id;
      setObs(cab?.obs ?? "");
    } else {
      setIdCabPre("");
      documentoId.current = "";
      setObs("");
    }
  }, [users?.emp_id, id, fetchDocs]);

  const loadPresupuestoDetalle = useCallback(async () => {
    if (!users?.emp_id || !idCabPre) {
      setPresupuesto([]);
      return;
    }
    const qDet = query(
      collection(db, "presupuestos"),
      where("emp_id", "==", users.emp_id),
      where("id_cab_pre", "==", idCabPre)
    );
    const rows = await fetchDocs(qDet);
    setPresupuesto(rows);
  }, [users?.emp_id, idCabPre, fetchDocs]);

  // const loadItems = useCallback(async () => {
  //   if (!users?.emp_id) return;
  //   const qIt = query(collection(db, "itemsst"), where("emp_id", "==", users.emp_id));
  //   const rows = await fetchDocs(qIt);
  //   setItems(rows);
  // }, [users?.emp_id, fetchDocs]);

  // Nuevo 20-08-2026 
  // const loadCabecera = useCallback(async () => {
  //   try {
  //     if (!id) {
  //       cabIdRef.current = "";
  //       return;
  //     }
  //     const qCab = query(
  //       collection(db, "bitacoracabbajasEq"),
  //       where("id_cab_inst", "==", id)
  //     );

  //     const rows = await fetchDocs(qCab);
  //     if (rows.length > 0) {
  //       cabIdRef.current = rows[0].id;
  //     } else {
  //       cabIdRef.current = "";
  //     }

  //   } catch (error) {
  //     console.error(
  //       "Error cargando cabecera:",
  //       error
  //     );

  //     cabIdRef.current = "";
  //   }
  // }, [id, fetchDocs]);

  // const loadEjecucion = useCallback(async () => {
  //   if (!users?.emp_id || cabIdRef.current) {
  //     setBajaDet([]);
  //     return;
  //   }
  //   const qE = query(
  //     collection(db, "bitacorabaja"),
  //     where("emp_id", "==", users.emp_id),
  //     where("id_cab_bitbaja", "==", cabIdRef.current)
  //   );
  //   const rows = await fetchDocs(qE);
  //   setBajaDet(rows);
  // }, [users?.emp_id, fetchDocs]);

  // const loadEjecucion = useCallback(async () => {
  //   if (!users?.emp_id || !cabIdRef.current) {
  //     setBajaDet([]);
  //     return;
  //   }

  //   const qE = query(
  //     collection(db, "bitacorabaja"),
  //     where("emp_id", "==", users.emp_id),
  //     where("id_cab_bitbaja", "==", cabIdRef.current)
  //   );

  //   const rows = await fetchDocs(qE);
  //   setBajaDet(rows);
  // }, [users?.emp_id, fetchDocs]);

  const loadItems = useCallback(async () => {
    if (!users?.emp_id) return;

    // itemsst => diag (F/R/S)
    const qItemsSt = query(collection(db, "itemsst"), where("emp_id", "==", users.emp_id));
    const rowsSt = await fetchDocs(qItemsSt);
    setItems(rowsSt);

  //   // items => ejec (CHECK/MED/SEG)
  //   const qItems = query(collection(db, "items"), where("emp_id", "==", users.emp_id));
  //   const rows = await fetchDocs(qItems);
  //   setItemsEjecMaster(rows);
  }, [users?.emp_id, fetchDocs]);

  // Hasta aqui 20-06-2026

  // const refreshAll = useCallback(async () => {
  //   setLoading(true);
  //   try {
  //     await loadPresupuestoCab();
  //     await loadCabecera();
  //     await loadEjecucion();
  //     await loadItems();
  //   } catch (e) {
  //     Swal.fire("Error cargando datos", String(e));
  //   } finally {
  //     setLoading(false);
  //   }
  // }, [loadPresupuestoCab, loadItems, loadCabecera, loadEjecucion]);

  const refreshAll = useCallback(async () => {
    setLoading(true);

    try {
      await loadPresupuestoCab();
      // await loadCabecera();
      // await loadEjecucion();
      await loadItems();

    } catch (e) {
      console.error(e);
      Swal.fire(
        "Error cargando datos",
        String(e)
      );

    } finally {
      setLoading(false);
    }
  }, [loadPresupuestoCab, /*loadCabecera, loadEjecucion,*/ loadItems]);

  useEffect(() => {
    if (!users?.emp_id || !id) return;
    refreshAll();
  }, [users?.emp_id, id, refreshAll]);

  useEffect(() => {
    loadPresupuestoDetalle();
  }, [loadPresupuestoDetalle]);

  // ===== Derivados =====
  const cabConfirmada = useMemo(() => presupuestoCab.find((x) => x.confirmado === true), [presupuestoCab]);
  const cabPendiente = useMemo(() => presupuestoCab.find((x) => x.confirmado === false), [presupuestoCab]);

  const presupuestoOrdenado = useMemo(() => {
    return [...presupuesto].sort((a, b) => toMillisSafe(a?.fechaadd) - toMillisSafe(b?.fechaadd));
  }, [presupuesto]);

  const esCorrectivaContrato = useMemo(() => {
    return (
      ingreso?.origen_ingreso === "TRASPASO_ST_INTERNO" &&
      ingreso?.servicio === "PRESUPUESTO"
    );
  }, [ingreso]);

  // Valor económico completo del presupuesto.
  // No alteramos los precios reales de los items.
  const totalReal = useMemo(() => {
    return presupuestoOrdenado.reduce(
      (acc, d) =>
        acc + Number(d.price ?? 0),
      0
    );
  }, [presupuestoOrdenado]);

  // Servicios que cubre el contrato.
  const totalCubiertoContrato = useMemo(() => {
    if (!esCorrectivaContrato) return 0;

    return presupuestoOrdenado
      .filter(
        (d) => d.categoria === "SERVICIO"
      )
      .reduce(
        (acc, d) =>
          acc + Number(d.price ?? 0),
        0
      );
  }, [
    presupuestoOrdenado,
    esCorrectivaContrato,
  ]);

  // Lo que efectivamente debe pagar el cliente.
  const totalPagar = useMemo(() => {
    if (!esCorrectivaContrato) {
      return totalReal;
    }

    return presupuestoOrdenado
      .filter(
        (d) => d.categoria === "REPUESTO"
      )
      .reduce(
        (acc, d) =>
          acc + Number(d.price ?? 0),
        0
      );
  }, [
    presupuestoOrdenado,
    esCorrectivaContrato,
    totalReal,
  ]);

  const itemrs = useMemo(() => {
    const itemF = items.filter((it) => it.categoria === "FALLA");
    const itemR = items.filter((it) => it.categoria === "REPUESTO");
    const itemS = items.filter((it) => it.categoria === "SERVICIO");
    const itemI = items.filter((it) => it.categoria === "IRREPARABLE");

    const ordenar = (a, b) => {
      const categoriaA = a.categoria ?? "";
      const categoriaB = b.categoria ?? "";
      if (categoriaA < categoriaB) return -1;
      if (categoriaA > categoriaB) return 1;

      const nombreA = a.nombre ?? "";
      const nombreB = b.nombre ?? "";
      if (nombreA < nombreB) return -1;
      if (nombreA > nombreB) return 1;
      return 0;
    };

    // return [...itemF, ...itemR, ...itemS, ...itemI].sort(ordenar);
    return {
      todos: [...itemF, ...itemR, ...itemS, ...itemI].sort(ordenar),
      fallas: itemF,
      repuestos: itemR,
      servicios: itemS,
      irreparables: itemI,
    };
  }, [items]);

  // Agregar si existe un IRREPARABLE seleccionado
  const tieneIrreparable = useMemo(() => {
    return presupuestoOrdenado.some((item) => item.categoria === "IRREPARABLE");
  }, [presupuestoOrdenado]);

  const filtroItemBase = useMemo(() => {
    //   return itemrs.filter((it) => !presupuestoOrdenado.some((p) => p.item_id === it.id));
    return itemrs.todos.filter((it) => !presupuestoOrdenado.some((p) => p.item_id === it.id));
  }, [itemrs, presupuestoOrdenado]);

  const filtroItem = useMemo(() => {
    if (verTodos) return filtroItemBase;

    const term = buscador.toLowerCase();
    if (!term) return [];

    return filtroItemBase.filter((it) => {
      const hay = [it.nombre, it.categoria, String(it.price ?? 0)].join(" ").toLowerCase();
      return hay.includes(term);
    });
  }, [verTodos, buscador, filtroItemBase]);


  // Nuevo 20-08-2026
  // const ejecOrdenado = useMemo(() => {
  //   return [...bajaDet].sort((a, b) => toMillisSafe(a?.fechaadd) - toMillisSafe(b?.fechaadd));
  // }, [bajaDet]);

  // const ejecInst = useMemo(
  //   () => ejecOrdenado.filter((it) => it.categoria === "INSTRUMENTOS"),
  //   [ejecOrdenado]
  // );
  // const ejecCheck = useMemo(
  //   () => ejecOrdenado.filter((it) => it.categoria === "CHECK"),
  //   [ejecOrdenado]
  // );
  // const ejecMed = useMemo(
  //   () => ejecOrdenado.filter((it) => it.categoria === "MEDICION"),
  //   [ejecOrdenado]
  // );
  // const ejecSeg = useMemo(
  //   () => ejecOrdenado.filter((it) => it.categoria === "SEGURIDAD"),
  //   [ejecOrdenado]
  // );

  // filtros: excluir ya agregados
  // const ejecMaster = useMemo(() => {
  //   return itemsEjecMaster
  //     .filter((it) => ["CHECK", "MEDICION", "SEGURIDAD", "INSTRUMENTOS"].includes(it.categoria))
  //     .sort((a, b) => toMillisSafe(a?.fechamod) - toMillisSafe(b?.fechamod));
  // }, [itemsEjecMaster]);

  // const ejecBase = useMemo(() => {
  //   // const ejecItems = [...ejecCheck, ...ejecMed, ...ejecSeg];
  //   const ejecItems = [...ejecInst, ...ejecCheck, ...ejecMed, ...ejecSeg];
  //   return ejecMaster.filter((it) => !ejecItems.some((d) => d.item_id === it.id));
  //   // }, [ejecMaster, ejecCheck, ejecMed, ejecSeg]);
  // }, [ejecMaster, ejecInst, ejecCheck, ejecMed, ejecSeg]);

  // const ejecFiltro = useMemo(() => {
  //   if (ejecVerTodos) return ejecBase;
  //   const term = qEjec.toLowerCase();
  //   if (!term) return [];
  //   return ejecBase.filter((it) => {
  //     const hay = [it.nombre, it.categoria].join(" ").toLowerCase();
  //     return hay.includes(term);
  //   });
  // }, [ejecVerTodos, qEjec, ejecBase]);
  // Hata aqui nuevo 20-08-2026

  // ===== Acciones =====
  const comenzarOContinuar = async () => {
    if (!users?.emp_id || !id) return;

    // si hay confirmada => no iniciar desde acá
    if (cabConfirmada) {
      Swal.fire("Ya existe un presupuesto confirmado. Usa 'Editar' si corresponde.");
      return;
    }

    // si ya hay pendiente => abrir edición
    if (cabPendiente) {
      documentoId.current = cabPendiente.id;
      setIdCabPre(cabPendiente.id);
      setObs(cabPendiente?.obs ?? "");
      setMostrarAdd(true);
      setBtnCabDisabled(true);
      return;
    }

    // crear cabecera nueva
    setSaving(true);
    try {
      const now = new Date();
      await PresupuestoCabDB({
        id_cab_inst: id,
        confirmado: false,
        estado: "PREPARACION",
        generado: false,
        fecha_generado: "",
        enviado: false,
        fecha_enviado: "",
        aceptado: false,
        fecha_aceptado: "",
        rechazado: false,
        fecha_rechazado: "",
        correctivo: false,
        fecha_correctivo: "",
        cerrado: false,
        fecha_cerrado: "",
        userAdd: user?.email ?? "",
        userMod: user?.email ?? "",
        fechaAdd: now,
        fechaMod: now,
        emp_id: users.emp_id,
        obs: obs ?? "",
      });

      await loadPresupuestoCab();
      setMostrarAdd(true);
      setBtnCabDisabled(true);

      Swal.fire({
        icon: "success",
        title: "Presupuesto iniciado",
        timer: 900,
        showConfirmButton: false,
      });
    } catch (e) {
      Swal.fire("Error creando cabecera", String(e));
    } finally {
      setSaving(false);
    }
  };

  const agregarItem = async (itemId) => {
    if (!users?.emp_id) return;

    if (!documentoId.current && !idCabPre) {
      Swal.fire("Primero presiona 'Comenzar Presupuesto'.");
      return;
    }
    if (botonDisabled) return;

    setBotonDisabled(true);
    try {
      // const it = itemrs.find((x) => x.id === itemId);
      const it = itemrs.todos.find((x) => x.id === itemId);
      if (!it) return;

      if (presupuestoOrdenado.some((p) => p.item_id === it.id)) {
        Swal.fire("Item ya está agregado.");
        return;
      }

      const cabId = idCabPre || documentoId.current;
      const now = new Date();

      await PresupuestoDB({
        id_cab_pre: cabId,
        item_id: it.id,
        item: it.nombre,
        categoria: it.categoria,
        price: Number(it.price),
        userAdd: user?.email ?? "",
        userMod: user?.email ?? "",
        fechaAdd: now,
        fechaMod: now,
        emp_id: users.emp_id,
      });

      await loadPresupuestoDetalle();
      // Limpiar buscador y cerrar resultados
      setBuscador("");
      setShowResultados(false);
      setVerTodos(false);

      Swal.fire({
        icon: "success",
        title: "Item agregado",
        timer: 800,
        showConfirmButton: false,
      });
    } catch (e) {
      Swal.fire("Error agregando item", String(e));
    } finally {
      setTimeout(() => setBotonDisabled(false), 500);
    }
  };

  const askDelete = (idDet, col) => {
    setDeleteId(idDet);
    setDeleteCol(col); // "diag" | "ejec"
    setOpenDelete(true);
  };

  // const doDelete = async () => {
  //   if (!deleteId) return;
  //   setOpenDelete(false);
  //   setSaving(true);
  //   try {
  //     await deleteDoc(doc(db, "presupuestos", deleteId));
  //     await loadPresupuestoDetalle();
  //     Swal.fire({ icon: "success", title: "Item eliminado", timer: 900, showConfirmButton: false });
  //   } catch (e) {
  //     Swal.fire("Error eliminando item", String(e));
  //   } finally {
  //     setSaving(false);
  //     setDeleteId("");
  //   }
  // };

  // Nuevo 20-08-2026
  const doDelete = async () => {
    if (!deleteId || !deleteCol) return;
    setOpenDelete(false);
    setSaving(true);
    try {
      if (deleteCol === "diag") {
        await deleteDoc(doc(db, "presupuestos", deleteId));
        await loadPresupuestoDetalle();
      } 
      // else {
      //   await deleteDoc(doc(db, "bitacorabaja", deleteId));
      //   await loadEjecucion();
      // }
    } catch (e) {
      Swal.fire("Error eliminando", String(e));
    } finally {
      setSaving(false);
      setDeleteId("");
      setDeleteCol(null);
    }
  };

  const canConfirm = useMemo(() => {
    if (presupuestoOrdenado.length === 0) { return { ok: false, msg: "No hay items agregados." } }
    const existeIrreparable = presupuestoOrdenado.some((d) => d.categoria === "IRREPARABLE");
    const existeF = presupuestoOrdenado.some((d) => d.categoria === "FALLA");
    const existeS = presupuestoOrdenado.some((d) => d.categoria === "SERVICIO");

    // Si existe IRREPARABLE, solo se exige SERVICIO
    if (existeIrreparable) {
      if (!existeS) { return { ok: false, msg: "Falta al menos 1 item de SERVICIO." } }
      return { ok: true, msg: "" }
    }
    // Comportamiento normal
    if (!existeF) { return { ok: false, msg: "Falta al menos 1 item de FALLA." } }
    if (!existeS) { return { ok: false, msg: "Falta al menos 1 item de SERVICIO." } }
    return { ok: true, msg: "" };
  }, [presupuestoOrdenado]);

  const confirmarGeneracion = async () => {
    const val = canConfirm;

    if (!val.ok) {
      return Swal.fire(val.msg);
    }

    setOpenConfirmGenerar(false);
    setSaving(true);

    try {
      const now = new Date();

      // Validar que exista cabecera de presupuesto
      if (!idCabPre) {
        throw new Error("No existe cabecera de presupuesto.");
      }

      // Determinar resolución del presupuesto
      // Si existe al menos un item IRREPARABLE,
      // este presupuesto corresponde a una BAJA_ST.
      const esBajaST = presupuestoOrdenado.some(
        (item) => item.categoria === "IRREPARABLE"
      );

      const batch = writeBatch(db);

      // Actualizar cabecera presupuesto
      batch.update(doc(db, "presupuestoscab", idCabPre), {
        confirmado: true,
        estado: "GENERADO",
        generado: true,
        fecha_generado: now,

        // Resolución del presupuesto
        tipo_resolucion: esBajaST ? "BAJA_ST" : "REPARACION",
        baja_st: esBajaST,
        estado_baja: esBajaST
          ? "PENDIENTE_EJECUCION"
          : "",

        usermod: user?.email ?? "",
        fechamod: now,
        obs: isEmpty(obs)
          ? "Sin Observaciones"
          : obs,
      });

      // Actualizar ingreso ST
      batch.update(doc(db, "ingresostcab", id), {
        estado_servicio: "GENERADO",
        usermod: user?.email ?? "",
        fechamod: now,
      });

      // Ejecutar ambas operaciones
      await batch.commit();

      // Recargar información
      await loadPresupuestoCab();
      await loadPresupuestoDetalle();

      setMostrarAdd(false);
      setBtnCabDisabled(false);

      Swal.fire({
        icon: "success",
        title: "Presupuesto confirmado",
        timer: 1000,
        showConfirmButton: false,
      });

    } catch (e) {
      console.error("Error confirmando presupuesto:", e);

      Swal.fire({
        icon: "error",
        title: "Error al confirmar",
        text: e?.message || String(e),
      });

    } finally {
      setSaving(false);
    }
  };

  const editar = async () => {
    if (!idCabPre) return;
    setSaving(true);
    try {
      const now = new Date();

      const batch = writeBatch(db);
      batch.update(doc(db, "presupuestoscab", idCabPre), {
        confirmado: false,
        estado: "GENERANDO",
        generado: false,
        usermod: user?.email ?? "",
        fechamod: now,
      });

      batch.update(doc(db, "ingresostcab", id), {
        estado_servicio: "",
        usermod: user?.email ?? "",
        fechamod: now,
      });

      await batch.commit();

      await loadPresupuestoCab();
      await loadPresupuestoDetalle();

      setMostrarAdd(true);
      setBtnCabDisabled(true);

      Swal.fire({
        icon: "success",
        title: "Modo edición habilitado",
        timer: 900,
        showConfirmButton: false,
      });
    } catch (e) {
      Swal.fire("Error al editar", String(e));
    } finally {
      setSaving(false);
    }
  };

  // Email HTML
  const cuerpoCorreo = (
    ing,
    presupuestoEnviar,
    cabeceraPresupuesto,
    urlAceptar
  ) => {
    const esCorrectivaContratoCorreo =
      ing?.origen_ingreso === "TRASPASO_ST_INTERNO" &&
      ing?.servicio === "PRESUPUESTO";

    const totalRealCorreo = presupuestoEnviar.reduce(
      (t, it) => t + Number(it.price ?? 0),
      0
    );

    const totalCubiertoContratoCorreo =
      esCorrectivaContratoCorreo
        ? presupuestoEnviar
          .filter((it) => it.categoria === "SERVICIO")
          .reduce(
            (t, it) => t + Number(it.price ?? 0),
            0
          )
        : 0;

    const totalPagarCorreo =
      esCorrectivaContratoCorreo
        ? presupuestoEnviar
          .filter((it) => it.categoria === "REPUESTO")
          .reduce(
            (t, it) => t + Number(it.price ?? 0),
            0
          )
        : totalRealCorreo;

    return ReactDOMServer.renderToString(
      <table width="100%" cellPadding="0" cellSpacing="0" border="0" style={{ backgroundColor: "#EEF2EF", padding: "20px 0", fontSize: "10px" }}>
        <tbody>
          <tr>
            <td align="center">
              <table width="100%" style={{ maxWidth: "600px", width: "100%", backgroundColor: "#ffffff", borderRadius: "4px", overflow: "hidden" }}>
                <tbody>
                  <tr>
                    <td align="center">
                      <img src={`https://logisticmed.cl/${users.emp_id}.png`} alt="Logo" style={{ width: "30%" }} />
                    </td>
                  </tr>
                  <tr>
                    <td style={{ backgroundColor: "#3A9A9D", padding: "20px", textAlign: "center" }}>
                      <h2 style={{ color: "#ffffff", margin: 0, fontSize: "12px" }}>
                        Estimado {nombre_out}, este es el presupuesto para la orden N° {ing.folio}
                      </h2>
                    </td>
                  </tr>

                  {/* Cliente */}
                  <tr>
                    <td style={{ padding: "20px", backgroundColor: "#EAF1FB", textAlign: "center" }}>
                      <h3 style={{ fontSize: "12px", marginBottom: "10px" }}>Información Cliente</h3>
                      <table width="100%" border="1" cellPadding="8" cellSpacing="0" style={{ borderCollapse: "collapse", fontSize: "10px" }}>
                        <thead>
                          <tr style={{ backgroundColor: "#EBEBEB" }}>
                            <th>Rut</th><th>Nombre</th><th>Fecha</th><th>Teléfono</th><th>Dirección</th><th>Correo</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr style={{ backgroundColor: "#F5F5F5" }}>
                            <td>{ing.rut}</td><td>{ing.entidad}</td><td>{formatearFecha(ing.date)}</td><td>{ing.telefono}</td><td>{ing.direccion}</td><td>{ing.correo}</td>
                          </tr>
                        </tbody>
                      </table>
                    </td>
                  </tr>

                  {/* Equipo */}
                  <tr>
                    <td style={{ padding: "20px", backgroundColor: "#EAF1FB", textAlign: "center" }}>
                      <h3 style={{ fontSize: "12px", marginBottom: "10px" }}>Información Equipo</h3>
                      <table width="100%" border="1" cellPadding="8" cellSpacing="0" style={{ borderCollapse: "collapse", fontSize: "10px" }}>
                        <thead>
                          <tr style={{ backgroundColor: "#EBEBEB" }}>
                            <th>Familia</th><th>Tipo</th><th>Marca</th><th>Modelo</th><th>Serie</th><th>Servicio</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr style={{ backgroundColor: "#F5F5F5" }}>
                            <td>{ing.familia}</td><td>{ing.tipo}</td><td>{ing.marca}</td><td>{ing.modelo}</td><td>{ing.serie}</td><td style={{ color: "red" }}>{ing.servicio}</td>
                          </tr>
                        </tbody>
                      </table>
                    </td>
                  </tr>
                  {/* FALLAS DIAGNOSTICADAS */}
                  <tr>
                    <td
                      style={{
                        padding: "20px",
                        backgroundColor: "#EAF1FB",
                        textAlign: "center",
                      }}
                    >
                      <h3
                        style={{
                          fontSize: "12px",
                          marginBottom: "10px",
                        }}
                      >
                        Falla(s) Diagnosticada(s)
                      </h3>

                      <table
                        width="100%"
                        border="1"
                        cellPadding="8"
                        cellSpacing="0"
                        style={{
                          borderCollapse: "collapse",
                          fontSize: "10px",
                        }}
                      >
                        <thead>
                          <tr style={{ backgroundColor: "#EBEBEB" }}>
                            <th style={{ width: "40px" }}>N°</th>
                            <th>Falla diagnosticada</th>
                          </tr>
                        </thead>

                        <tbody>
                          {presupuestoEnviar
                            .filter((x) => x.categoria === "FALLA")
                            .map((x, i) => (
                              <tr
                                key={i}
                                style={{ backgroundColor: "#F5F5F5" }}
                              >
                                <td>{i + 1}</td>

                                <td
                                  style={{
                                    textAlign: "left",
                                    fontWeight: "600",
                                  }}
                                >
                                  {x.item}
                                </td>
                              </tr>
                            ))}
                        </tbody>
                      </table>
                    </td>
                  </tr>

                  {/* PRESUPUESTO */}
                  <tr>
                    <td
                      style={{
                        padding: "20px",
                        backgroundColor: "#EAF1FB",
                        textAlign: "center",
                      }}
                    >
                      <h3
                        style={{
                          fontSize: "12px",
                          marginBottom: "10px",
                        }}
                      >
                        Presupuesto
                      </h3>

                      <table
                        width="100%"
                        border="1"
                        cellPadding="8"
                        cellSpacing="0"
                        style={{
                          borderCollapse: "collapse",
                          fontSize: "10px",
                        }}
                      >
                        <thead>
                          <tr style={{ backgroundColor: "#EBEBEB" }}>
                            <th>N°</th>
                            <th>Item</th>
                            <th>Categoría</th>
                            <th>Valor</th>
                            <th>Condición</th>
                          </tr>
                        </thead>

                        <tbody>
                          {presupuestoEnviar
                            .filter(
                              (x) =>
                                x.categoria === "SERVICIO" ||
                                x.categoria === "REPUESTO"
                            )
                            .map((x, i) => {
                              const servicioCubierto =
                                esCorrectivaContratoCorreo &&
                                x.categoria === "SERVICIO";

                              const repuestoCobrado =
                                esCorrectivaContratoCorreo &&
                                x.categoria === "REPUESTO";

                              return (
                                <tr
                                  key={i}
                                  style={{
                                    backgroundColor: "#F5F5F5",
                                  }}
                                >
                                  <td>{i + 1}</td>

                                  <td style={{ textAlign: "left" }}>
                                    {x.item}
                                  </td>

                                  <td>{x.categoria}</td>

                                  <td
                                    style={{
                                      textAlign: "right",
                                      whiteSpace: "nowrap",
                                    }}
                                  >
                                    $
                                    {Number(
                                      x.price ?? 0
                                    ).toLocaleString()}
                                    .-
                                  </td>

                                  <td
                                    style={{
                                      fontWeight: "700",
                                      color: servicioCubierto
                                        ? "#00a89d"
                                        : "#333333",
                                    }}
                                  >
                                    {servicioCubierto
                                      ? "CUBIERTO POR CONTRATO"
                                      : repuestoCobrado
                                        ? "A PAGAR"
                                        : ""}
                                  </td>
                                </tr>
                              );
                            })}

                          {esCorrectivaContratoCorreo ? (
                            <>
                              <tr style={{ backgroundColor: "#EBEBEB" }}>
                                <td
                                  colSpan="4"
                                  style={{
                                    textAlign: "right",
                                    fontWeight: "bold",
                                  }}
                                >
                                  Valor total servicios y repuestos:
                                </td>

                                <td
                                  style={{
                                    textAlign: "right",
                                    fontWeight: "bold",
                                    whiteSpace: "nowrap",
                                  }}
                                >
                                  ${totalRealCorreo.toLocaleString()}.-
                                </td>
                              </tr>

                              <tr style={{ backgroundColor: "#F3FFFD" }}>
                                <td
                                  colSpan="4"
                                  style={{
                                    textAlign: "right",
                                    fontWeight: "bold",
                                    color: "#00a89d",
                                  }}
                                >
                                  Servicios cubiertos por contrato:
                                </td>

                                <td
                                  style={{
                                    textAlign: "right",
                                    fontWeight: "bold",
                                    color: "#00a89d",
                                    whiteSpace: "nowrap",
                                  }}
                                >
                                  -${totalCubiertoContratoCorreo.toLocaleString()}.-
                                </td>
                              </tr>

                              <tr style={{ backgroundColor: "#EBEBEB" }}>
                                <td
                                  colSpan="4"
                                  style={{
                                    textAlign: "right",
                                    fontWeight: "bold",
                                    fontSize: "11px",
                                  }}
                                >
                                  TOTAL A PAGAR:
                                </td>

                                <td
                                  style={{
                                    textAlign: "right",
                                    fontWeight: "bold",
                                    fontSize: "11px",
                                    whiteSpace: "nowrap",
                                  }}
                                >
                                  ${totalPagarCorreo.toLocaleString()}.-
                                </td>
                              </tr>
                            </>
                          ) : (
                            <tr style={{ backgroundColor: "#EBEBEB" }}>
                              <td
                                colSpan="4"
                                style={{
                                  textAlign: "right",
                                  fontWeight: "bold",
                                }}
                              >
                                Total:
                              </td>

                              <td
                                style={{
                                  textAlign: "right",
                                  fontWeight: "bold",
                                  whiteSpace: "nowrap",
                                }}
                              >
                                ${totalRealCorreo.toLocaleString()}.-
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </td>
                  </tr>

                  {/* Obs */}
                  <tr>
                    <td style={{ padding: "20px", backgroundColor: "#EAF1FB", textAlign: "center" }}>
                      <table width="100%" border="1" cellPadding="8" cellSpacing="0" style={{ borderCollapse: "collapse", fontSize: "10px" }}>
                        <thead>
                          <tr style={{ backgroundColor: "#EBEBEB" }}>
                            <th>Observaciones</th>
                          </tr>
                        </thead>
                        <tbody>
                          {cabeceraPresupuesto.map((c, i) => (
                            <tr key={i} style={{ backgroundColor: "#F5F5F5" }}>
                              <td>{c.obs}</td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </td>
                  </tr>

                </tbody>
              </table>
            </td>
          </tr>

          <tr>
            <td style={{ padding: "20px", textAlign: "center", backgroundColor: "#ffffff" }}>
              <a
                href={urlAceptar}
                style={{
                  display: "inline-block",
                  backgroundColor: "#21ba45",
                  color: "#fff",
                  padding: "12px 18px",
                  borderRadius: "8px",
                  textDecoration: "none",
                  fontWeight: "700",
                }}
              >
                Aceptar Presupuesto
              </a>

            </td>
          </tr>


        </tbody>
      </table>
    );
  };

  const enviar = async () => {
    setSaving(true);
    try {
      const regexMail = /[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+/;
      if (isEmpty(nombre_out)) return Swal.fire("Debe ingresar nombre del cliente");
      if (isEmpty(correo_out)) return Swal.fire("Debe ingresar correo del cliente");
      if (!regexMail.test(correo_out)) return Swal.fire("Correo inválido");

      if (!idCabPre) throw new Error("No existe cabecera para enviar.");

      // detalle
      const qDet = query(
        collection(db, "presupuestos"),
        where("emp_id", "==", users.emp_id),
        where("id_cab_pre", "==", idCabPre)
      );
      const detalle = await fetchDocs(qDet);

      const now = new Date();

      // estado enviado
      await updateDoc(doc(db, "presupuestoscab", idCabPre), {
        estado: "ENVIADO",
        enviado: true,
        fecha_enviado: now,
        usermod: user?.email ?? "",
        fechamod: now,
      });

      // token
      const token = generarTokenHex(32);
      const tokenExpira = Timestamp.fromDate(new Date(Date.now() + 24 * 60 * 60 * 1000));
      await updateDoc(doc(db, "presupuestoscab", idCabPre), {
        aceptarToken: token,
        aceptarTokenExpira: tokenExpira,
      });

      const baseUrl = process.env.REACT_APP_ACEPTAR_PRESUPUESTO_URL;
      const urlAceptar = `${baseUrl}?cabInstId=${encodeURIComponent(id)}&token=${encodeURIComponent(token)}`;


      // ema
      EnviarCorreo(correo_out, "Presupuesto:", cuerpoCorreo(ingreso, detalle, presupuestoCab, urlAceptar));




      // update ingreso
      await updateDoc(doc(db, "ingresostcab", id), {
        estado_servicio: "ENVIADO",
        usermod: user?.email ?? "",
        fechamod: now,
      });

      await loadPresupuestoCab();
      await loadPresupuestoDetalle();

      setOpenSend(false);
      Swal.fire({ icon: "success", title: "Presupuesto enviado", timer: 1000, showConfirmButton: false });
    } catch (e) {
      Swal.fire("Error enviando presupuesto", String(e));
    } finally {
      setSaving(false);
    }
  };

  const aceptar = async () => {
    setOpenAceptar(false);
    setSaving(true);
    try {
      if (!idCabPre) throw new Error("No existe cabecera.");

      const now = new Date();
      await updateDoc(doc(db, "presupuestoscab", idCabPre), {
        estado: "ACEPTADO",
        aceptado: true,
        fecha_aceptado: now,
        cerrado: true,
        fecha_cerrado: now,
        usermod: user?.email ?? "",
        fechamod: now,
      });

      await updateDoc(doc(db, "ingresostcab", id), {
        estado_servicio: "ACEPTADO",
        fecha_out: now,
        usermod: user?.email ?? "",
        fechamod: now,
      });

      await loadPresupuestoCab();
      volver();
    } catch (e) {
      Swal.fire("Error al aceptar", String(e));
    } finally {
      setSaving(false);
    }
  };

  const rechazar = async () => {
    setOpenRechazar(false);
    setSaving(true);
    try {
      if (!idCabPre) throw new Error("No existe cabecera.");

      const now = new Date();
      await updateDoc(doc(db, "presupuestoscab", idCabPre), {
        estado: "RECHAZADO",
        rechazado: true,
        fecha_rechazado: now,
        cerrado: true,
        fecha_cerrado: now,
        usermod: user?.email ?? "",
        fechamod: now,
      });

      await updateDoc(doc(db, "ingresostcab", id), {
        estado: "REALIZADO",
        estado_servicio: "RECHAZADO",
        fecha_out: now,
        usermod: user?.email ?? "",
        fechamod: now,
      });

      await loadPresupuestoCab();
      volver();
    } catch (e) {
      Swal.fire("Error al rechazar", String(e));
    } finally {
      setSaving(false);
    }
  };

  // Aqui lo nuevo 20-08-2026
  // const agregarEjecItem = async (itemId) => {
  //   setSaving(true);
  //   try {
  //     const it = ejecMaster.find((x) => x.id === itemId);
  //     if (!it) return;

  //     const ya = ejecOrdenado.some((d) => d.item_id === it.id);
  //     if (ya) {
  //       Swal.fire("Item ya está agregado.");
  //       return;
  //     }

  //     const now = new Date();
  //     await BitacoraBajaDB({
  //       folio: datos?.folio ?? "",
  //       id_cab_bitbaja: cabIdRef.current,
  //       id_cab_inst: id,
  //       item_id: it.id,
  //       item: it.nombre,
  //       categoria: it.categoria,
  //       medida: it.medida,
  //       inicial: it.inicial !== undefined ? parseFloat(it.inicial) : 0,
  //       final: it.final !== undefined ? parseFloat(it.final) : 0,
  //       valor: "",
  //       userAdd: user?.email ?? "",
  //       userMod: user?.email ?? "",
  //       fechaAdd: now,
  //       fechaMod: now,
  //       emp_id: users.emp_id,
  //     });

  //     await loadEjecucion();
  //   } catch (e) {
  //     Swal.fire("Error agregando item", String(e));
  //   } finally {
  //     setSaving(false);
  //   }
  // };

  // update valores de medición/seguridad en memoria (optimista)
  // const updateMedValor = (idDoc, valor) => {
  //   setBajaDet((prev) =>
  //     prev.map((x) => (x.id === idDoc ? { ...x, valor } : x))
  //   );
  // };
  // const updateSegValor = (idDoc, valor) => {
  //   setBajaDet((prev) =>
  //     prev.map((x) => (x.id === idDoc ? { ...x, valor } : x))
  //   );
  // };

  // finalizar: validar que si hay MED/SEG, no estén vacíos. (CHECK no requiere valor)
  // const canFinalizar = useMemo(() => {
  //   const existeEjec = ejecOrdenado.length > 0;
  //   if (!existeEjec) return { ok: false, msg: "Agrega al menos 1 item de ejecución." };

  //   const medEmpty = ejecMed.filter((x) => isEmpty(x.valor));
  //   const segEmpty = ejecSeg.filter((x) => isEmpty(x.valor));

  //   if (medEmpty.length) return { ok: false, msg: "Hay items de MEDICIÓN sin valor." };
  //   if (segEmpty.length) return { ok: false, msg: "Hay items de SEGURIDAD sin valor." };

  //   return { ok: true, msg: "" };
  // }, [ejecOrdenado, ejecMed, ejecSeg]);

  // Ultimo Nuevo 26-08-2026
  // const guardarValoresEjec = useCallback(async () => {
  //   // guarda valores medición/seguridad
  //   const now = new Date();
  //   const batch = writeBatch(db);
  //   const ref = collection(db, "bitacorabaja");

  //   ejecMed.forEach((d) => {
  //     batch.update(doc(ref, d.id), { valor: d.valor, usermod: user?.email ?? "", fechamod: now });
  //   });
  //   ejecSeg.forEach((d) => {
  //     batch.update(doc(ref, d.id), { valor: d.valor, usermod: user?.email ?? "", fechamod: now });
  //   });

  //   await batch.commit();
  // }, [ejecMed, ejecSeg, user?.email]);

  // const confirmarFinalizar = async () => {
  //   const validacion = canFinalizar;

  //   if (!validacion.ok) {
  //     return Swal.fire({
  //       icon: "warning",
  //       title: "No se puede finalizar",
  //       text: validacion.msg,
  //     });
  //   }

  //   if (!cabIdRef.current) {
  //     return Swal.fire({
  //       icon: "warning",
  //       title: "Cabecera no encontrada",
  //       text: "No se encontró la cabecera de la garantía.",
  //     });
  //   }

  //   setSaving(true);

  //   try {
  //     // 1. Guardar valores ingresados en medición y seguridad.
  //     await guardarValoresEjec();

  //     const now = new Date();
  //     const observaciones = obsBaja.trim();

  //     const irreparable = presupuestoOrdenado.find((item) => item.categoria === "IRREPARABLE");

  //     // 2. Crear referencia para nuevo documento bajaEquipos
  //     // ---------------------------------------------------------
  //     const bajaEquiposRef = doc(collection(db, "bajaequipos"));

  //     // 2. Actualizar ingreso y cabecera en una sola operación.
  //     const batch = writeBatch(db);

  //     batch.update(doc(db, "ingresostcab", id), {
  //       enproceso: "0",
  //       estado: "REALIZADO",
  //       estado_servicio: "REALIZADO",
  //       fecha_out: now,
  //       usermod: user?.email ?? "",
  //       fechamod: now,
  //     });
  //     console.log("se actualizo OE")
  //     batch.update(doc(db, "bitacoracabbajasEq", cabIdRef.current), {
  //       confirmado: true,
  //       cerrado: true,
  //       estado: "REALIZADO",
  //       fecha_cerrado: now,

  //       // Campo opcional. Si no se escribe nada, queda "".
  //       observaciones: observaciones,

  //       usermod: user?.email ?? "",
  //       fechamod: now,
  //     });
  //     console.log("se actualizo bitacora cabecera baja")

  //     batch.set(bajaEquiposRef, {
  //       folio_oe: datos.folio,
  //       id_cab_inst: id,
  //       id_presupuesto: idCabPre,
  //       id_bitacoracabbaja: cabIdRef.current,
  //       familia: datos.familia,
  //       tipo: datos.tipo,
  //       marca: datos.marca,
  //       modelo: datos.modelo,
  //       serie: datos.serie,
  //       irreparable: irreparable ?? null,
  //       observaciones: observaciones,

  //       fechabaja: now,
  //       fechaadd: now,
  //       fechamod: now,
  //       useradd: user?.email ?? "",
  //       usermod: user?.email ?? "",
  //       emp_id: users?.emp_id ?? null,
  //     });
  //     console.log("se creo baja equipo")

  //     await batch.commit();

  //     setOpenFinalizar(false);
  //     setObsBaja("");

  //     await Swal.fire({
  //       icon: "success",
  //       title: "Baja de Equipo finalizada",
  //       text: "La ejecución fue finalizada correctamente.",
  //       timer: 1400,
  //       showConfirmButton: false,
  //     });

  //     volver();
  //   } catch (error) {
  //     console.error(
  //       "Error finalizando baja equipo:",
  //       error
  //     );

  //     Swal.fire({
  //       icon: "error",
  //       title: "Error finalizando baja equipo",
  //       text:
  //         error?.message ||
  //         "No fue posible finalizar la baja de equipo.",
  //     });
  //   } finally {
  //     setSaving(false);
  //   }
  // };

  // const confirmarFinalizar = async () => {
  //   const validacion = canFinalizar;

  //   if (!validacion.ok) {
  //     return Swal.fire({
  //       icon: "warning",
  //       title: "No se puede finalizar",
  //       text: validacion.msg,
  //     });
  //   }

  //   if (!cabIdRef.current) {
  //     return Swal.fire({
  //       icon: "warning",
  //       title: "Cabecera no encontrada",
  //       text: "No se encontró la cabecera de la baja.",
  //     });
  //   }

  //   if (!id) {
  //     return Swal.fire({
  //       icon: "warning",
  //       title: "Ingreso no encontrado",
  //       text: "No se encontró el ID del ingreso.",
  //     });
  //   }

  //   setSaving(true);
  //   try {
  //     // 1. Guardar valores ingresados en medición y seguridad.
  //     await guardarValoresEjec();

  //     const now = new Date();
  //     const observaciones = obsBaja?.trim() ?? "";

  //     // BUSCAR ITEM IRREPARABLE
  //     const irreparable = presupuestoOrdenado.find((item) => item.categoria === "IRREPARABLE");

  //     if (!irreparable) { throw new Error("No se encontró el item IRREPARABLE en presupuestoOrdenado.") }

  //     // VALIDAR SERIE
  //     const serie = datos?.serie?.trim();

  //     if (!serie) {
  //       return Swal.fire({
  //         icon: "warning",
  //         title: "Serie no encontrada",
  //         text: "El equipo no tiene una serie válida.",
  //       });
  //     }

  //     // VALIDAR SI EL EQUIPO YA EXISTE EN bajaEquipos
  //     const qBajaEquipo = query(collection(db, "bajaEquipos"), where("serie", "==", serie));
  //     const snapshotBajaEquipo = await getDocs(qBajaEquipo);
  //     if (!snapshotBajaEquipo.empty) {
  //       return Swal.fire({
  //         icon: "warning",
  //         title: "Equipo ya dado de baja",
  //         text: `El equipo con serie ${serie} ya existe en bajaEquipos.`,
  //       });
  //     }

  //     // REFERENCIAS
  //     const ingresoRef = doc(db, "ingresostcab", id);
  //     const cabeceraBajaRef = doc(db, "bitacoracabbajasEq", cabIdRef.current);
  //     const bajaEquiposRef = doc(collection(db, "bajaEquipos"));

  //     // BATCH
  //     const batch = writeBatch(db);

  //     // 1. Actualizar ingreso
  //     batch.update(ingresoRef, {
  //       enproceso: "0",
  //       estado: "REALIZADO",
  //       estado_servicio: "REALIZADO",
  //       fecha_out: now,
  //       usermod: user?.email ?? "",
  //       fechamod: now,
  //     });

  //     // 2. Actualizar cabecera
  //     batch.update(cabeceraBajaRef, {
  //       confirmado: true,
  //       cerrado: true,
  //       estado: "REALIZADO",
  //       fecha_cerrado: now,
  //       observaciones: observaciones,
  //       usermod: user?.email ?? "",
  //       fechamod: now,
  //     });

  //     // 3. Crear bajaEquipos
  //     batch.set(bajaEquiposRef, {
  //       folio_oe: datos?.folio ?? "",
  //       id_cab_inst: id,
  //       id_presupuesto: idCabPre ?? "",
  //       id_bitacoracabbaja: cabIdRef.current,

  //       familia: datos?.familia ?? "",
  //       tipo: datos?.tipo ?? "",
  //       marca: datos?.marca ?? "",
  //       modelo: datos?.modelo ?? "",
  //       serie: serie,

  //       irreparable: irreparable.item,
  //       // observaciones: observaciones,
  //       observaciones: isEmpty(observaciones) ? "Sin Observaciones" : observaciones,

  //       fechabaja: now,
  //       fechaadd: now,
  //       fechamod: now,

  //       useradd: user?.email ?? "",
  //       usermod: user?.email ?? "",
  //       emp_id: users?.emp_id ?? null,
  //     }
  //     );

  //     // COMMIT
  //     await batch.commit();

  //     // ÉXITO
  //     setOpenFinalizar(false);
  //     setObsBaja("");

  //     await Swal.fire({
  //       icon: "success",
  //       title: "Baja de Equipo finalizada",
  //       text: "La ejecución fue finalizada correctamente.",
  //       timer: 1400,
  //       showConfirmButton: false,
  //     });

  //     volver();

  //   } catch (error) {
  //     console.error(
  //       "ERROR FINALIZANDO BAJA:",
  //       error
  //     );

  //     await Swal.fire({
  //       icon: "error",
  //       title: "No se pudo finalizar",
  //       text:
  //         error?.message ||
  //         "No se realizó ninguna modificación.",
  //     });

  //   } finally {
  //     setSaving(false);
  //   }
  // };
  // Hasta aqui lo nuevo 27-08-2026


  // ===== Render guards =====
  if (!datos) {
    return (
      <Container>
        <Segment>
          <Message info icon>
            <Icon name="info circle" />
            <Message.Content>
              <Message.Header>Cargando ingreso...</Message.Header>
            </Message.Content>
          </Message>
        </Segment>
      </Container>
    );
  }
  // console.log(presupuestoOrdenado)
  const isConfirmado = !!cabConfirmada;
  const esBajaST =
    cabConfirmada?.tipo_resolucion === "BAJA_ST";

  return (
    <Container style={{ paddingBottom: 24 }}>
      <Segment
        style={{
          background: "#ffffff",
          border: "1px solid #e5e9ef",
          borderRadius: 9,
          boxShadow: "0 2px 8px rgba(23,43,77,0.04)",
          padding: "20px 24px",
          marginBottom: 18,
        }}
      >
        <Header
          as="h2"
          style={{
            margin: 0,
            color: "#172b4d",
            fontSize: 23,
            fontWeight: 700,
          }}
        >
          <Icon
            name="file alternate outline"
            style={{ color: "#0d9da5" }}
          />
          <Header.Content>
            Generar Presupuesto
            <Header.Subheader
              style={{
                color: "#66758c",
                fontSize: 13,
                fontWeight: 400,
                marginTop: 6,
              }}
            >
              Crea, revisa y genera la documentación del presupuesto
            </Header.Subheader>
          </Header.Content>
        </Header>
      </Segment>

      <Dimmer active={loading || saving} inverted>
        <Loader>{saving ? "Procesando..." : "Cargando..."}</Loader>
      </Dimmer>

      {/* ==================== VISTA CONFIRMADA ==================== */}
      {isConfirmado && (
        <Segment raised>
          <Header as="h3">
            <Icon name="check circle" color="green" />
            <Header.Content>Presupuesto Confirmado</Header.Content>
          </Header>

          <TablaInfo ingreso={ingreso} presupuestoCab={[cabConfirmada]} id_cab_pre={idCabPre} ruta={ruta} />

          <Divider />
          {esBajaST ? (
            <>
              <Message warning icon>
                <Icon name="trash alternate" />

                <Message.Content>
                  <Message.Header>
                    Baja de Servicio Técnico generada
                  </Message.Header>

                  Esta resolución no requiere aceptación del cliente.

                  <br />

                  Estado:{" "}
                  <strong>
                    {cabConfirmada?.estado_baja === "PENDIENTE_EJECUCION"
                      ? "Pendiente de ejecución técnica"
                      : cabConfirmada?.estado_baja || "Pendiente"}
                  </strong>
                </Message.Content>
              </Message>

              <Grid>
                <Grid.Row columns={2}>
                  <Grid.Column>
                    <Button basic onClick={volver}>
                      <Icon name="arrow left" />
                      Volver
                    </Button>
                  </Grid.Column>

                  <Grid.Column textAlign="right">
                    <Button
                      color="red"
                      onClick={() => navigate(`/ejecutarpresupuestost/${id}`)}
                    >
                      <Icon name="play" />
                      Ejecutar Baja ST
                    </Button>
                  </Grid.Column>
                </Grid.Row>
              </Grid>
            </>
          ) : cabConfirmada?.enviado === false ? (
            <Grid>
              <Grid.Row columns={2}>
                <Grid.Column>
                  <Button
                    color="teal"
                    onClick={() => {
                      setNombre_out(ingreso.entidad);
                      setCorreo_out(ingreso.correo);
                      setOpenSend(true);
                    }}
                  >
                    <Icon name="send" />
                    Enviar
                  </Button>
                </Grid.Column>

                <Grid.Column textAlign="right">
                  <Button color="orange" onClick={editar}>
                    <Icon name="edit" />
                    Editar
                  </Button>
                </Grid.Column>
              </Grid.Row>
            </Grid>
          ) : (
            <Grid>
              <Grid.Row columns={2}>
                <Grid.Column>
                  <Button
                    color="green"
                    onClick={() => setOpenAceptar(true)}
                  >
                    <Icon name="check" />
                    Aceptar
                  </Button>
                </Grid.Column>

                <Grid.Column textAlign="right">
                  <Button
                    color="red"
                    onClick={() => setOpenRechazar(true)}
                  >
                    <Icon name="ban" />
                    Rechazar
                  </Button>
                </Grid.Column>
              </Grid.Row>
            </Grid>
          )}

        </Segment>
      )}

      {/* ==================== CREACIÓN / EDICIÓN ==================== */}
      {!isConfirmado && (
        <>
          {/* CLIENTE / EQUIPO */}
          <Segment raised>
            <Grid verticalAlign="middle">
              <Grid.Row columns={2}>
                <Grid.Column>
                  <Header as="h3">
                    <Icon name="user" />
                    <Header.Content>Información Cliente / Equipo</Header.Content>
                  </Header>
                </Grid.Column>
                <Grid.Column textAlign="right">
                  <Button basic icon onClick={() => setShowCliente((s) => !s)}>
                    <Icon name={showCliente ? "angle up" : "angle down"} />
                  </Button>
                </Grid.Column>
              </Grid.Row>
            </Grid>

            {showCliente && (
              <>
                <Table celled compact size="small">
                  <Table.Header>
                    <Table.Row>
                      <Table.HeaderCell>Folio</Table.HeaderCell>
                      <Table.HeaderCell>Rut</Table.HeaderCell>
                      <Table.HeaderCell>Nombre</Table.HeaderCell>
                      <Table.HeaderCell>Fecha</Table.HeaderCell>
                      <Table.HeaderCell>Teléfono</Table.HeaderCell>
                      <Table.HeaderCell>Dirección</Table.HeaderCell>
                      <Table.HeaderCell>Email</Table.HeaderCell>
                    </Table.Row>
                  </Table.Header>
                  <Table.Body>
                    <Table.Row>
                      <Table.Cell>{datos.folio}</Table.Cell>
                      <Table.Cell>{datos.rut}</Table.Cell>
                      <Table.Cell>{datos.entidad}</Table.Cell>
                      <Table.Cell>{datos.date ? formatearFecha(datos.date) : "-"}</Table.Cell>
                      <Table.Cell>{datos.telefono}</Table.Cell>
                      <Table.Cell>{datos.direccion}</Table.Cell>
                      <Table.Cell>{datos.correo}</Table.Cell>
                    </Table.Row>
                  </Table.Body>
                </Table>

                <Table celled compact size="small">
                  <Table.Header>
                    <Table.Row>
                      <Table.HeaderCell>Familia</Table.HeaderCell>
                      <Table.HeaderCell>Tipo</Table.HeaderCell>
                      <Table.HeaderCell>Marca</Table.HeaderCell>
                      <Table.HeaderCell>Modelo</Table.HeaderCell>
                      <Table.HeaderCell>Serie</Table.HeaderCell>
                      <Table.HeaderCell>Servicio</Table.HeaderCell>
                    </Table.Row>
                  </Table.Header>
                  <Table.Body>
                    <Table.Row>
                      <Table.Cell>{datos.familia}</Table.Cell>
                      <Table.Cell>{datos.tipo}</Table.Cell>
                      <Table.Cell>{datos.marca}</Table.Cell>
                      <Table.Cell>{datos.modelo}</Table.Cell>
                      <Table.Cell>{datos.serie}</Table.Cell>
                      <Table.Cell>{datos.servicio}</Table.Cell>
                    </Table.Row>
                  </Table.Body>
                </Table>

                <Button
                  color="teal"
                  onClick={comenzarOContinuar}
                  disabled={btnCabDisabled || loading || saving}
                  title={btnCabDisabled ? "Ya iniciado" : "Iniciar/Continuar"}
                >
                  <Icon name="play" />
                  {cabPendiente ? "Continuar Presupuesto" : "Comenzar Presupuesto"}
                </Button>
              </>
            )}
          </Segment>

          {/* FORMULARIO ITEMS */}
          {mostrarAdd && (
            <Segment raised color="red">
              <Header as="h3">
                <Icon name="list" />
                <Header.Content>Items del Presupuesto</Header.Content>
              </Header>

              {/* Buscador flotante */}
              <div style={{ position: "relative" }}>
                <Input
                  fluid
                  icon="search"
                  placeholder="Buscar y agregar items (Enter: ver todos / cerrar)"
                  value={buscador}
                  onChange={(e) => {
                    const value = e.target.value;
                    setBuscador(value);

                    if (value.trim() === "") {
                      setShowResultados(false);
                      setVerTodos(false);
                    } else {
                      setVerTodos(false);
                      setShowResultados(true);
                    }
                  }}
                  onKeyDown={(e) => {
                    if (e.key === "Enter") {
                      e.preventDefault();

                      if (!verTodos && !showResultados) {
                        setVerTodos(true);
                        setShowResultados(true);
                        return;
                      }

                      if (verTodos || showResultados) {
                        setVerTodos(false);
                        setShowResultados(false);
                        setBuscador("");
                      }
                    }
                  }}
                />

                {showResultados && (
                  <div
                    style={{
                      position: "absolute",
                      top: "100%",
                      left: 0,
                      right: 0,
                      maxHeight: 260,
                      overflowY: "auto",
                      border: "1px solid #ddd",
                      borderRadius: 6,
                      background: "#fff",
                      boxShadow: "0 6px 16px rgba(0,0,0,0.15)",
                      marginTop: 6,
                      zIndex: 1000,
                    }}
                  >
                    <Table compact celled singleLine>
                      <Table.Header
                        style={{
                          position: "sticky",
                          top: 0,
                          zIndex: 2,
                          background: "#f8f8f8",
                        }}
                      >
                        <Table.Row>
                          <Table.HeaderCell style={{ width: 60 }}>N°</Table.HeaderCell>
                          <Table.HeaderCell>Nombre</Table.HeaderCell>
                          <Table.HeaderCell style={{ width: 140 }}>Categoría</Table.HeaderCell>
                          <Table.HeaderCell style={{ width: 120 }}>Precio</Table.HeaderCell>
                          <Table.HeaderCell style={{ width: 90, textAlign: "center" }}>
                            Agregar
                          </Table.HeaderCell>
                        </Table.Row>
                      </Table.Header>

                      <Table.Body>
                        {filtroItem.map((it, idx) => (
                          <Table.Row
                            key={it.id}
                            onMouseEnter={() => setHover(it.id)}
                            onMouseLeave={() => setHover(null)}
                            style={{
                              cursor: "pointer",
                              backgroundColor: hover === it.id ? "#F2F2F2" : "white",
                            }}
                          >
                            <Table.Cell>{idx + 1}</Table.Cell>
                            <Table.Cell>{it.nombre}</Table.Cell>
                            <Table.Cell>{it.categoria}</Table.Cell>
                            <Table.Cell>
                              <div>
                                ${Number(
                                  it.price ?? 0
                                ).toLocaleString()}.-
                              </div>

                              {esCorrectivaContrato &&
                                it.categoria === "SERVICIO" && (
                                  <div
                                    style={{
                                      marginTop: 3,
                                      fontSize: 11,
                                      fontWeight: 700,
                                      color: "#00a89d",
                                    }}
                                  >
                                    <Icon name="check circle" />
                                    Cubierto por contrato
                                  </div>
                                )}
                            </Table.Cell>
                            <Table.Cell textAlign="center">
                              <Popup
                                content="Agregar item"
                                inverted
                                trigger={
                                  <Icon
                                    name="add circle"
                                    color={botonDisabled ? "grey" : "teal"}
                                    size="large"
                                    style={{ cursor: "pointer" }}
                                    onClick={() => agregarItem(it.id)}
                                  />
                                }
                              />
                            </Table.Cell>
                          </Table.Row>
                        ))}

                        {filtroItem.length === 0 && (
                          <Table.Row>
                            <Table.Cell colSpan={5} textAlign="center">
                              No hay coincidencias{buscador ? ` para "${buscador}"` : ""}.
                            </Table.Cell>
                          </Table.Row>
                        )}
                      </Table.Body>
                    </Table>
                  </div>
                )}
              </div>

              <Divider />

              {/* Tabla items agregados */}
              <Table celled compact size="small">
                <Table.Header>
                  <Table.Row>
                    <Table.HeaderCell width={1}>N°</Table.HeaderCell>
                    <Table.HeaderCell>Item</Table.HeaderCell>
                    <Table.HeaderCell width={3}>Categoría</Table.HeaderCell>
                    <Table.HeaderCell width={3}>Precio</Table.HeaderCell>
                    <Table.HeaderCell width={2}>Eliminar</Table.HeaderCell>
                  </Table.Row>
                </Table.Header>

                <Table.Body>
                  {presupuestoOrdenado.map((it, idx) => (
                    <Table.Row key={it.id}>
                      <Table.Cell>{idx + 1}</Table.Cell>
                      <Table.Cell style={{ whiteSpace: "normal" }}>{it.item}</Table.Cell>
                      <Table.Cell>{it.categoria}</Table.Cell>
                      <Table.Cell>${Number(it.price ?? 0).toLocaleString()}.-</Table.Cell>
                      <Table.Cell>
                        {/* <Button basic color="red" size="tiny" onClick={() => askDelete(it.id)}> */}
                        <Button basic color="red" size="tiny" onClick={() => askDelete(it.id, "diag")}>
                          <Icon name="trash" /> Eliminar
                        </Button>
                      </Table.Cell>
                    </Table.Row>
                  ))}

                  {presupuestoOrdenado.length === 0 && (
                    <Table.Row>
                      <Table.Cell colSpan={5} textAlign="center">
                        Aún no hay items agregados
                      </Table.Cell>
                    </Table.Row>
                  )}
                </Table.Body>

                <Table.Footer>
                  {esCorrectivaContrato ? (
                    <>
                      <Table.Row>
                        <Table.HeaderCell
                          colSpan={3}
                          textAlign="right"
                        >
                          Valor total servicios y repuestos
                        </Table.HeaderCell>

                        <Table.HeaderCell colSpan={2}>
                          ${totalReal.toLocaleString()}.-
                        </Table.HeaderCell>
                      </Table.Row>

                      <Table.Row>
                        <Table.HeaderCell
                          colSpan={3}
                          textAlign="right"
                          style={{
                            color: "#00a89d",
                          }}
                        >
                          <Icon name="check circle" />
                          Servicios cubiertos por contrato
                        </Table.HeaderCell>

                        <Table.HeaderCell
                          colSpan={2}
                          style={{
                            color: "#00a89d",
                          }}
                        >
                          -${totalCubiertoContrato.toLocaleString()}.-
                        </Table.HeaderCell>
                      </Table.Row>

                      <Table.Row>
                        <Table.HeaderCell
                          colSpan={3}
                          textAlign="right"
                          style={{
                            fontSize: 15,
                          }}
                        >
                          <b>TOTAL A PAGAR</b>
                        </Table.HeaderCell>

                        <Table.HeaderCell
                          colSpan={2}
                          style={{
                            fontSize: 15,
                          }}
                        >
                          <b>
                            ${totalPagar.toLocaleString()}.-
                          </b>
                        </Table.HeaderCell>
                      </Table.Row>
                    </>
                  ) : (
                    <Table.Row>
                      <Table.HeaderCell
                        colSpan={3}
                        textAlign="right"
                      >
                        <b>Total</b>
                      </Table.HeaderCell>

                      <Table.HeaderCell colSpan={2}>
                        <b>
                          ${totalReal.toLocaleString()}.-
                        </b>
                      </Table.HeaderCell>
                    </Table.Row>
                  )}
                </Table.Footer>
              </Table>

              <Segment>
                <Header as="h4">
                  <Icon name="sticky note" />
                  <Header.Content>Observaciones</Header.Content>
                </Header>
                <TextArea
                  value={obs}
                  onChange={(e) => setObs(e.target.value)}
                  placeholder="Ingrese observación o detalles adicionales"
                  style={{ minHeight: 90, width: "100%" }}
                />
              </Segment>

              {!canConfirm.ok && (
                <Message warning icon>
                  <Icon name="warning circle" />
                  <Message.Content>
                    <Message.Header>Antes de confirmar</Message.Header>
                    {canConfirm.msg}
                  </Message.Content>
                </Message>
              )}

              <Grid>
                <Grid.Row columns={2}>
                  <Grid.Column>
                    <Button basic onClick={volver}>
                      <Icon name="arrow left" /> Volver
                    </Button>
                  </Grid.Column>
                  <Grid.Column textAlign="right">
                    {/* <Button
                      color="green"
                      onClick={() => setOpenConfirmGenerar(true)}
                      disabled={saving || loading || presupuestoOrdenado.length === 0}
                      title="Confirmar y generar presupuesto"
                    >
                      <Icon name="check" /> Confirmar
                    </Button> */}
                    <Button
                      color={tieneIrreparable ? "red" : "green"}
                      onClick={() => setOpenConfirmGenerar(true)}
                      disabled={
                        saving ||
                        loading ||
                        presupuestoOrdenado.length === 0 ||
                        !canConfirm.ok
                      }
                      title={
                        tieneIrreparable
                          ? "Generar resolución de Baja ST"
                          : "Confirmar y generar presupuesto"
                      }
                    >
                      <Icon
                        name={
                          tieneIrreparable
                            ? "trash alternate"
                            : "check"
                        }
                      />

                      {tieneIrreparable
                        ? "Generar Baja ST"
                        : "Confirmar"}
                    </Button>

                  </Grid.Column>
                </Grid.Row>
              </Grid>
            </Segment>
          )}
        </>
      )}

      {/* ==================== MODALES ==================== */}

      {/* Delete */}
      <Modal size="small" open={openDelete} onClose={() => setOpenDelete(false)}>
        <Modal.Header>Eliminar item</Modal.Header>
        <Modal.Content>
          <Message warning icon>
            <Icon name="warning circle" />
            <Message.Content>
              <Message.Header>¿Eliminar este item?</Message.Header>
              Esta acción no se puede deshacer.
            </Message.Content>
          </Message>
        </Modal.Content>
        <Modal.Actions>
          <Button onClick={() => setOpenDelete(false)}>
            <Icon name="close" /> Cancelar
          </Button>
          <Button color="red" onClick={doDelete}>
            <Icon name="trash" /> Eliminar
          </Button>
        </Modal.Actions>
      </Modal>

      {/* Confirmar generar */}
      <Modal
        size="small"
        open={openConfirmGenerar}
        onClose={() => setOpenConfirmGenerar(false)}
      >
        <Modal.Header>
          {tieneIrreparable
            ? "Generar Baja ST"
            : "Confirmar Presupuesto"}
        </Modal.Header>

        <Modal.Content>
          <Message warning icon>
            <Icon name="warning circle" />

            <Message.Content>
              <Message.Header>
                {tieneIrreparable
                  ? "¿Confirmar y generar la resolución de Baja ST?"
                  : "¿Confirmar y generar el presupuesto?"}
              </Message.Header>

              {tieneIrreparable ? (
                <>
                  La resolución quedará como <b>BAJA ST</b> pendiente
                  de ejecución técnica.
                </>
              ) : (
                <>
                  Esto marcará el documento como <b>GENERADO</b>.
                </>
              )}
            </Message.Content>
          </Message>
        </Modal.Content>

        <Modal.Actions>
          <Button onClick={() => setOpenConfirmGenerar(false)}>
            <Icon name="close" />
            Cancelar
          </Button>

          <Button
            color={tieneIrreparable ? "red" : "green"}
            onClick={() => {
              if (!canConfirm.ok) {
                return Swal.fire(canConfirm.msg);
              }

              confirmarGeneracion();
            }}
          >
            <Icon name="check" />

            {tieneIrreparable
              ? "Generar Baja ST"
              : "Confirmar"}
          </Button>
        </Modal.Actions>
      </Modal>

      {/* Enviar */}
      <Modal size="small" open={openSend} onClose={() => setOpenSend(false)}>
        <Modal.Header>Enviar Presupuesto</Modal.Header>
        <Modal.Content>
          <Form>
            <Form.Input
              label="Nombre"
              icon="user"
              iconPosition="left"
              placeholder="Nombre cliente"
              value={nombre_out}
              onChange={(e) => setNombre_out(e.target.value)}
            />
            <Form.Input
              label="Correo"
              icon="mail"
              iconPosition="left"
              placeholder="correo@dominio.cl"
              value={correo_out}
              onChange={(e) => setCorreo_out(e.target.value)}
            />
          </Form>
        </Modal.Content>
        <Modal.Actions>
          <Button onClick={() => setOpenSend(false)}>
            <Icon name="close" /> Cancelar
          </Button>
          <Button color="teal" onClick={enviar}>
            <Icon name="send" /> Enviar
          </Button>
        </Modal.Actions>
      </Modal>

      {/* Aceptar */}
      <Modal size="small" open={openAceptar} onClose={() => setOpenAceptar(false)}>
        <Modal.Header>Aceptar Presupuesto</Modal.Header>
        <Modal.Content>
          <Message warning icon>
            <Icon name="warning circle" />
            <Message.Content>
              <Message.Header>¿Seguro que deseas aceptar?</Message.Header>
              Esto cerrará el presupuesto como <b>ACEPTADO</b>.
            </Message.Content>
          </Message>
        </Modal.Content>
        <Modal.Actions>
          <Button onClick={() => setOpenAceptar(false)}>
            <Icon name="close" /> Cancelar
          </Button>
          <Button color="green" onClick={aceptar}>
            <Icon name="check" /> Aceptar
          </Button>
        </Modal.Actions>
      </Modal>

      {/* Rechazar */}
      <Modal size="small" open={openRechazar} onClose={() => setOpenRechazar(false)}>
        <Modal.Header>Rechazar Presupuesto</Modal.Header>
        <Modal.Content>
          <Message warning icon>
            <Icon name="warning circle" />
            <Message.Content>
              <Message.Header>¿Seguro que deseas rechazar?</Message.Header>
              Esto cerrará el presupuesto como <b>RECHAZADO</b>.
            </Message.Content>
          </Message>
        </Modal.Content>
        <Modal.Actions>
          <Button onClick={() => setOpenRechazar(false)}>
            <Icon name="close" /> Cancelar
          </Button>
          <Button color="red" onClick={rechazar}>
            <Icon name="ban" /> Rechazar
          </Button>
        </Modal.Actions>
      </Modal>

      {/* Dar Baja */}
      {/* <Modal open={openBajaModal} onClose={() => setOpenBajaModal(false)} size="large" >
        <Modal.Header><Icon name="trash alternate" />Dar de Baja Equipo</Modal.Header>
        <Modal.Content scrolling>
        // INFORMACIÓN DEL CLIENTE
          <Table celled compact size="small">
            <Table.Header>
              <Table.Row>
                <Table.HeaderCell>Folio</Table.HeaderCell>
                <Table.HeaderCell>Rut</Table.HeaderCell>
                <Table.HeaderCell>Nombre</Table.HeaderCell>
                <Table.HeaderCell>Fecha</Table.HeaderCell>
                <Table.HeaderCell>Teléfono</Table.HeaderCell>
                <Table.HeaderCell>Dirección</Table.HeaderCell>
                <Table.HeaderCell>Email</Table.HeaderCell>
              </Table.Row>
            </Table.Header>
            <Table.Body>
              <Table.Row>
                <Table.Cell>{datos.folio}</Table.Cell>
                <Table.Cell>{datos.rut}</Table.Cell>
                <Table.Cell>{datos.entidad}</Table.Cell>
                <Table.Cell>{datos.date ? formatearFecha(datos.date) : "-"}</Table.Cell>
                <Table.Cell>{datos.telefono}</Table.Cell>
                <Table.Cell>{datos.direccion}</Table.Cell>
                <Table.Cell>{datos.correo}</Table.Cell>
              </Table.Row>
            </Table.Body>
          </Table>

          // INFORMACIÓN DEL EQUIPO
          <Table celled compact size="small">
            <Table.Header>
              <Table.Row>
                <Table.HeaderCell>Familia</Table.HeaderCell>
                <Table.HeaderCell>Tipo</Table.HeaderCell>
                <Table.HeaderCell>Marca</Table.HeaderCell>
                <Table.HeaderCell>Modelo</Table.HeaderCell>
                <Table.HeaderCell>Serie</Table.HeaderCell>
                <Table.HeaderCell>Servicio</Table.HeaderCell>
              </Table.Row>
            </Table.Header>
            <Table.Body>
              <Table.Row>
                <Table.Cell>{datos.familia}</Table.Cell>
                <Table.Cell>{datos.tipo}</Table.Cell>
                <Table.Cell>{datos.marca}</Table.Cell>
                <Table.Cell>{datos.modelo}</Table.Cell>
                <Table.Cell>{datos.serie}</Table.Cell>
                <Table.Cell>{datos.servicio}</Table.Cell>
              </Table.Row>
            </Table.Body>
          </Table>

          // ITEM IRREPARABLE
          <Segment>
            <Header as="h4">
              <Icon name="warning sign" />
              <Header.Content>
                Item Irreparable
              </Header.Content>
            </Header>

            <Table celled striped compact>
              <Table.Header>
                <Table.Row>
                  <Table.HeaderCell>Item</Table.HeaderCell>
                  <Table.HeaderCell>Categoria</Table.HeaderCell>
                </Table.Row>
              </Table.Header>

              <Table.Body>
                {presupuestoOrdenado.filter((item) => item.categoria === "IRREPARABLE").map((item, index) => (
                  <Table.Row key={item.id ?? index}>
                    <Table.Cell>{item.item ?? ""}</Table.Cell>
                    <Table.Cell>{item.categoria ?? ""}</Table.Cell>
                  </Table.Row>
                ))}
              </Table.Body>
            </Table>
          </Segment>

          // SERVICIO 
          <Segment>
            <Header as="h4">
              <Icon name="wrench" />
              <Header.Content>Servicio</Header.Content>
            </Header>

            <Table celled striped compact>
              <Table.Header>
                <Table.Row>
                  <Table.HeaderCell>Servicio</Table.HeaderCell>
                  <Table.HeaderCell>Categoria</Table.HeaderCell>
                  <Table.HeaderCell>Valor</Table.HeaderCell>
                </Table.Row>
              </Table.Header>

              <Table.Body>
                {presupuestoOrdenado
                  .filter((item) => item.categoria === "SERVICIO")
                  .map((item, index) => (
                    <Table.Row key={item.id ?? index}>
                      <Table.Cell>{item.item ?? ""}</Table.Cell>
                      <Table.Cell>{item.categoria ?? ""}</Table.Cell>
                      <Table.Cell textAlign="right">${Number(item.price ?? 0).toLocaleString()}.-</Table.Cell>
                    </Table.Row>
                  ))}
              </Table.Body>
            </Table>
          </Segment>

          // EJECUCION BAJA
          <Segment raised color="red">
            <Header as="h3">
              <Icon name="tasks" />
              <Header.Content>Ejecución</Header.Content>
            </Header>


            <div style={{ position: "relative" }}>
              <Input
                fluid
                icon="search"
                placeholder="Buscar y agregar items ejecución (Enter: ver todos / cerrar)"
                value={qEjec}
                onChange={(e) => {
                  const v = e.target.value;
                  setQEjec(v);
                  if (v.trim() === "") {
                    setShowEjecResultados(false);
                    setEjecVerTodos(false);
                  } else {
                    setEjecVerTodos(false);
                    setShowEjecResultados(true);
                  }
                }}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    e.preventDefault();
                    if (!ejecVerTodos && !showEjecResultados) {
                      setEjecVerTodos(true);
                      setShowEjecResultados(true);
                      return;
                    }
                    if (ejecVerTodos || showEjecResultados) {
                      setEjecVerTodos(false);
                      setShowEjecResultados(false);
                      setQEjec("");
                    }
                  }
                }}
              />

              {showEjecResultados && (
                <div
                  style={{
                    position: "absolute",
                    top: "100%",
                    left: 0,
                    right: 0,
                    maxHeight: 260,
                    overflowY: "auto",
                    border: "1px solid #ddd",
                    borderRadius: 6,
                    background: "#fff",
                    boxShadow: "0 6px 16px rgba(0,0,0,0.15)",
                    marginTop: 6,
                    zIndex: 1000,
                  }}
                >
                  <Table compact celled singleLine>
                    <Table.Header
                      style={{
                        position: "sticky",
                        top: 0,
                        zIndex: 2,
                        background: "#f8f8f8",
                      }}
                    >
                      <Table.Row>
                        <Table.HeaderCell style={{ width: 60 }}>N°</Table.HeaderCell>
                        <Table.HeaderCell>Nombre</Table.HeaderCell>
                        <Table.HeaderCell style={{ width: 160 }}>Categoría</Table.HeaderCell>
                        <Table.HeaderCell style={{ width: 90, textAlign: "center" }}>Agregar</Table.HeaderCell>
                      </Table.Row>
                    </Table.Header>

                    <Table.Body>
                      {ejecFiltro.map((it, idx) => (
                        <Table.Row
                          key={it.id}
                          onMouseEnter={() => setHoverId(it.id)}
                          onMouseLeave={() => setHoverId(null)}
                          style={{
                            cursor: "pointer",
                            backgroundColor: hoverId === it.id ? "#F2F2F2" : "white",
                          }}
                        >
                          <Table.Cell>{idx + 1}</Table.Cell>
                          <Table.Cell>{it.nombre}</Table.Cell>
                          <Table.Cell>{it.categoria}</Table.Cell>
                          <Table.Cell textAlign="center">
                            <Popup
                              content="Agregar item"
                              inverted
                              trigger={
                                <Icon
                                  name="add circle"
                                  color="teal"
                                  size="large"
                                  style={{ cursor: "pointer" }}
                                  onClick={() => {
                                    agregarEjecItem(it.id);
                                    setShowEjecResultados(false);
                                    setQEjec("");
                                    setEjecVerTodos(false);
                                  }}
                                />
                              }
                            />
                          </Table.Cell>
                        </Table.Row>
                      ))}

                      {ejecFiltro.length === 0 && (
                        <Table.Row>
                          <Table.Cell colSpan={4} textAlign="center">
                            No hay coincidencias{qEjec ? ` para "${qEjec}"` : ""}.
                          </Table.Cell>
                        </Table.Row>
                      )}
                    </Table.Body>
                  </Table>
                </div>
              )}
            </div>

            <Divider />

            // INSTRUMENTOS
            {ejecInst.length > 0 && (
              <>
                <Header as="h4">
                  <Icon name="check square" />
                  <Header.Content>Check</Header.Content>
                </Header>

                <Table celled compact size="small">
                  <Table.Header>
                    <Table.Row>
                      <Table.HeaderCell width={1}>N°</Table.HeaderCell>
                      <Table.HeaderCell>Item</Table.HeaderCell>
                      <Table.HeaderCell width={3}>Categoría</Table.HeaderCell>
                      <Table.HeaderCell width={2}>Eliminar</Table.HeaderCell>
                    </Table.Row>
                  </Table.Header>
                  <Table.Body>
                    {ejecInst.map((it, idx) => (
                      <Table.Row key={it.id}>
                        <Table.Cell>{idx + 1}</Table.Cell>
                        <Table.Cell style={{ whiteSpace: "normal" }}>{it.item}</Table.Cell>
                        <Table.Cell>{it.categoria}</Table.Cell>
                        <Table.Cell>
                          <Button basic color="red" size="tiny" onClick={() => askDelete(it.id, "ejec")}>
                            <Icon name="trash" /> Eliminar
                          </Button>
                        </Table.Cell>
                      </Table.Row>
                    ))}
                  </Table.Body>
                </Table>
              </>
            )}

            // CHECK
            {ejecCheck.length > 0 && (
              <>
                <Header as="h4">
                  <Icon name="check square" />
                  <Header.Content>Check</Header.Content>
                </Header>

                <Table celled compact size="small">
                  <Table.Header>
                    <Table.Row>
                      <Table.HeaderCell width={1}>N°</Table.HeaderCell>
                      <Table.HeaderCell>Item</Table.HeaderCell>
                      <Table.HeaderCell width={3}>Categoría</Table.HeaderCell>
                      <Table.HeaderCell width={2}>Eliminar</Table.HeaderCell>
                    </Table.Row>
                  </Table.Header>
                  <Table.Body>
                    {ejecCheck.map((it, idx) => (
                      <Table.Row key={it.id}>
                        <Table.Cell>{idx + 1}</Table.Cell>
                        <Table.Cell style={{ whiteSpace: "normal" }}>{it.item}</Table.Cell>
                        <Table.Cell>{it.categoria}</Table.Cell>
                        <Table.Cell>
                          <Button basic color="red" size="tiny" onClick={() => askDelete(it.id, "ejec")}>
                            <Icon name="trash" /> Eliminar
                          </Button>
                        </Table.Cell>
                      </Table.Row>
                    ))}
                  </Table.Body>
                </Table>
              </>
            )}

            // MEDICION
            {ejecMed.length > 0 && (
              <>
                <Header as="h4">
                  <Icon name="sliders horizontal" />
                  <Header.Content>Medición</Header.Content>
                </Header>

                <Table celled compact size="small">
                  <Table.Header>
                    <Table.Row>
                      <Table.HeaderCell width={1}>N°</Table.HeaderCell>
                      <Table.HeaderCell>Item</Table.HeaderCell>
                      <Table.HeaderCell width={3}>Valor</Table.HeaderCell>
                      <Table.HeaderCell width={3}>Rango</Table.HeaderCell>
                      <Table.HeaderCell width={3}>Medida</Table.HeaderCell>
                      <Table.HeaderCell width={2}>Eliminar</Table.HeaderCell>
                    </Table.Row>
                  </Table.Header>
                  <Table.Body>
                    {ejecMed.map((it, idx) => (
                      <Table.Row key={it.id}>
                        <Table.Cell>{idx + 1}</Table.Cell>
                        <Table.Cell>{it.item}</Table.Cell>
                        <Table.Cell>
                          <Input
                            type="number"
                            value={it.valor ?? ""}
                            onChange={(e) => updateMedValor(it.id, e.target.value)}
                          />
                        </Table.Cell>
                        <Table.Cell>
                          {String(it.inicial ?? "")} - {String(it.final ?? "")}
                        </Table.Cell>
                        <Table.Cell>{it.medida}</Table.Cell>
                        <Table.Cell>
                          <Button basic color="red" size="tiny" onClick={() => askDelete(it.id, "ejec")}>
                            <Icon name="trash" /> Eliminar
                          </Button>
                        </Table.Cell>
                      </Table.Row>
                    ))}
                  </Table.Body>
                </Table>
              </>
            )}

            // SEGURIDAD
            {ejecSeg.length > 0 && (
              <>
                <Header as="h4">
                  <Icon name="shield alternate" />
                  <Header.Content>Seguridad</Header.Content>
                </Header>

                <Table celled compact size="small">
                  <Table.Header>
                    <Table.Row>
                      <Table.HeaderCell>Item</Table.HeaderCell>
                      <Table.HeaderCell width={6}>Valor</Table.HeaderCell>
                      <Table.HeaderCell width={2}>Eliminar</Table.HeaderCell>
                    </Table.Row>
                  </Table.Header>
                  <Table.Body>
                    {ejecSeg.map((it) => (
                      <Table.Row key={it.id}>
                        <Table.Cell>{it.item}</Table.Cell>
                        <Table.Cell>
                          <Input
                            type="number"
                            value={it.valor ?? ""}
                            onChange={(e) => updateSegValor(it.id, e.target.value)}
                          />
                        </Table.Cell>
                        <Table.Cell>
                          <Button basic color="red" size="tiny" onClick={() => askDelete(it.id, "ejec")}>
                            <Icon name="trash" /> Eliminar
                          </Button>
                        </Table.Cell>
                      </Table.Row>
                    ))}
                  </Table.Body>
                </Table>
              </>
            )}

            {!canFinalizar.ok && (
              <Message warning icon>
                <Icon name="warning circle" />
                <Message.Content>
                  <Message.Header>Antes de finalizar</Message.Header>
                  {canFinalizar.msg}
                </Message.Content>
              </Message>
            )}

          </Segment>

          // OBSERVACIONES DEL TÉCNICO 
          <Segment>
            <Header as="h4">
              <Icon name="clipboard outline" />
              <Header.Content>
                Observaciones del Técnico
              </Header.Content>
            </Header>

            <Form>
              <Form.TextArea
                label="Observaciones"
                placeholder="Ingrese las observaciones del técnico..."
                value={obsBaja}
                onChange={(e, { value }) => setObsBaja(value)}
                rows={5}
              />
            </Form>
          </Segment>
        </Modal.Content>
        <Modal.Actions>

          <Button onClick={() => setOpenBajaModal(false)} disabled={saving}>
            <Icon name="cancel" />
            Cancelar
          </Button>

          // <Button negative onClick={onDarBaja} disabled={saving} loading={saving}>
            // <Icon name="trash alternate" /> Dar Baja
          // </Button>

          <Button
            negative
            // color="green"
            onClick={() => {
              if (!canFinalizar.ok) {
                Swal.fire({
                  icon: "warning",
                  title: "Antes de finalizar",
                  text: canFinalizar.msg,
                });
                return;
              }
              setOpenFinalizar(true);
            }}
            disabled={
              saving ||
              loading ||
              ejecOrdenado.length === 0
            }
          >
            <Icon name="flag checkered" />
            Dar Baja
          </Button>

        </Modal.Actions>
      </Modal> */}

      {/* MODAL FINALIZAR BAJA EQUIPO */}
      {/* <Modal
        size="small"
        open={openFinalizar}
        closeOnDimmerClick={!saving}
        closeOnEscape={!saving}
        onClose={() => { if (!saving) { setOpenFinalizar(false) } }}
      >
        <Modal.Header><Icon name="flag checkered" />Finalizar Equipo para Baja</Modal.Header>
        <Modal.Content>
          {!canFinalizar.ok && (
            <Message warning icon>
              <Icon name="warning circle" />

              <Message.Content>
                <Message.Header>
                  No se puede finalizar
                </Message.Header>

                {canFinalizar.msg}
              </Message.Content>
            </Message>
          )}

          <Message warning icon>
            <Icon name="warning sign" />

            <Message.Content>
              <Message.Header>
                Confirmación
              </Message.Header>

              Se guardarán los valores ingresados y el
              equipo será marcado como{" "}
              <strong>Dado de Baja</strong>.
            </Message.Content>
          </Message>
        </Modal.Content>

        <Modal.Actions>
          <Button
            disabled={saving}
            onClick={() => {
              setOpenFinalizar(false);
            }}
          >
            <Icon name="close" />
            Cancelar
          </Button>

          <Button
            color="green"
            loading={saving}
            disabled={
              saving ||
              loading ||
              !canFinalizar.ok
            }
            onClick={confirmarFinalizar}
          >
            <Icon name="flag checkered" />
            Finalizar Baja Equipo
          </Button>
        </Modal.Actions>
      </Modal> */}

      {/* Footer */}
      <Divider hidden />
      <Button basic onClick={volver}>
        <Icon name="arrow left" /> Volver
      </Button>
    </Container>
  );
};

export default GenerarPresupuesto;